import { FC, useCallback } from 'react';
import { cn } from '../utils';

type RichTextProps = {
  children?: string | null;
  className?: string;
};

export const RichText: FC<RichTextProps> = ({ children, className }) => {
  const containerRef = useCallback((node: HTMLDivElement | null) => {
    if (node !== null) {
      const anchors = node.querySelectorAll<HTMLAnchorElement>('a[href]');
      for (const anchor of anchors) {
        if (!anchor.target) {
          anchor.target = '_blank';
        }
      }
    }
  }, []);

  if (!children) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={cn('l-rich-text', className)}
      dangerouslySetInnerHTML={{
        __html: children,
      }}
    />
  );
};
